/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobQueryCounter {
    getFixupPrototypeFunction() { return BackgroundJobQueryCounter.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobQueryCounter>): BackgroundJobQueryCounter {
        let obj = Object.assign(new BackgroundJobQueryCounter(), model);
        BackgroundJobQueryCounter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobQueryCounter>): BackgroundJobQueryCounter {
        if (!model) return null;
        return BackgroundJobQueryCounter.newInstance(<BackgroundJobQueryCounter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobQueryCounter) {
        if (!obj) return;

        models.BackgroundJobQueryCounter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobQueryCounter): boolean {
        Object.setPrototypeOf(obj, BackgroundJobQueryCounter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.hits === undefined) {
            this.hits = 0;
        }
        if (this.execution_time === undefined) {
            this.execution_time = 0;
        }
    }

    /**
     * Counter identifier
     */
    identifier: string;

    /**
     * Operation
     */
    action: string;

    /**
     * Summarized query
     */
    parametrized_query: any;

    /**
     * Query Plan
     */
    query_planner: any;

    /**
     * Total number of calls
     */
    hits: number;

    /**
     * Total execution time in seconds
     */
    execution_time: number;

}
